<template>
  <div class="container-fluid">
    <Loading v-if="this.$store.state.isLoading" />
    <AlertDialog v-if="this.$store.state.isAlertDialog" />
    <div
      class="row header bt-primary justify-content-between align-items-center"
    >
      <div class="col-auto">
        <img class="titleimg" src="@/assets/acrypro/logo.svg" style="cursor: pointer" @click="backhome"/>
      </div>
      <div class="col-auto">
        <a href="#" class="text-dark me-3" style="text-decoration: none" @click="contact">お問い合わせ</a>
      </div>
    </div>
    <div class="row" style="height: 40px"></div>
    <div class="row">
      <div class="col text-center">
        <p class="noto acry-foreground h3 fw-bold">契約書</p>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col text-center">
        <p class="m-0 p-0 fw-bold">本サービスを使用するには契約書への署名が必要です。</p>
        <p class="m-0 p-0 fw-bold">{{ this.email }} 宛に署名依頼のメールを送信します。</p>
        <p class="m-0 p-0 fw-bold">メールに記載されたURLをクリックして、認証を完了させてください。</p>
        <br />
        <div class="text-start mx-auto" style="width:450px">
          <p class="small p-0 m-0">・署名依頼メールはnoreply@gmosign.comからお送りしています。</p>
          <p class="small p-0 m-0">・メールが届かない場合は、メールアドレスが間違っているか、迷惑メールフォルダに届いてしまっている可能性があります。</p>
          <p class="small p-0 m-0"></p>
        </div>
      </div>
    </div>
    <div class="row my-4">
      <div class="col">
        <hr class="w-75 mx-auto" />
      </div>
    </div>
     <button class="acry-normal-btn fw-bold" style="border:none" @click="sendRequest"><span style="font-size:20px">署名依頼の送信</span></button>
  </div>
</template>

<script>
import router from "@/router";
import { User } from "@/js/User.js";
import firebase from "firebase/app";
import Loading from "@/components/modal/dialog/Loading.vue";
import AlertDialog from "@/components/acyrpro/modal/dialog/AlertDialog_Ap.vue";
import "firebase/auth";
import { Analytics } from "@/js/Analytics.js";

export default {
  name: "AcryProContract",
  components: {
    Loading,
    AlertDialog,
  },
  props: {},
  async created() {
    this.$store.commit("showLoading");
    // 契約書IDを確認しすでにIDがある場合は、そのままホームに遷移
    await User.getFBAcryProUserData().then((data) => {
      if (data.envelopeXID) {
        router.replace('/home');
      }
    });

    this.$store.commit("hideLoading");
  },
  data() {
    return {
      isSend: false,
    };
  },
  computed: {
    email() {
      return firebase.auth().currentUser.email;
    },
  },
  methods: {
    async sendRequest() {
      if (this.isSend) return;
      this.isSend = true;
      this.$store.commit("showLoading");

      // ユーザーデータを取得
      const userInfo = await User.getInfo().catch((e) => {
        this.$handleError("080", e, { hideLoading: true });
        this.isSend = false;
      });

      const fbUserData = await User.getFBAcryProUserData().catch((e) => {
          this.$handleError("081", e, { hideLoading: true });
          this.isSend = false;
      });

      // ここに追加の情報を追加
      if( fbUserData && "isIndividual" in fbUserData && fbUserData.isIndividual ){
        userInfo.is_individual = 1;
      }else{
        userInfo.is_individual = 0;
      }

      if( fbUserData && "representative" in fbUserData && fbUserData.representative ){
        userInfo.representative_name = fbUserData.representative;
      }else{
        userInfo.representative_name = "";
      }

      // 署名の依頼を送信
      var response = await User.sendRequest(userInfo);
      if (response["envelope_xid"] != null) {
        // 結果を保存
          User.updateFBAcryProInfo({
            isSendRequest: true,
            envelopeXID: response["envelope_xid"],
          })
          .then(() => {
            Analytics.contractSubmitted();
            this.$store.commit("hideLoading");
            this.$store.commit("setAlertDialogCallback", ()=>
            {
              router.replace('/home');
            });
            this.$store.commit(
              "showMessage",
              "署名依頼がメールで届きますのでご確認ください"
            );
          })
          .catch((e) => {
            this.$handleError("082", e, { hideLoading: true });
            this.isSend = false;
          });
      } else {
        this.$handleError("083", new Error("署名依頼の応答に envelope_xid が含まれない"), { hideLoading: true });
        this.isSend = false;
      }
    },
    backhome(){
      router.push("/");
    },
    contact() {
      router.push("/contact");
    },
  },
};
</script>

<style scoped>
</style>
